import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import { ScaledSheet } from '@utils/scale';

import HeaderWithBackAndTitle from '@components/HeaderWithBackAndTitle';
import TabSelector from './components/TabSelector';
import DailyTabContainer from './containers/DailyTabContainer';
import WeeklyTabContainer from './containers/WeeklyTabContainer';
import { ReportType } from './types';

type EarningsRouteParams = {
  nav_params?: {
    type?: ReportType;
    date?: string;
  };
};

/**
 * Earnings Screen Component
 * Main container that manages tab switching between Daily and Weekly reports
 */
const Earnings: React.FC = () => {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<{ params: EarningsRouteParams }, 'params'>>();
  const { nav_params } = route.params || {};
  const { type = 'WEEKLY', date = '' } = nav_params || {};
  const [reportType, setReportType] = useState<ReportType>(type);
  
  /**
   * Handles report type change (Daily/Weekly)
   */
  const handleReportTypeChange = (type: ReportType) => {
    setReportType(type);
  };

  return (
    <>
      <HeaderWithBackAndTitle
        headertitle="Earnings"
        subHeaderTitle=""
        headerStyle={{}}
        navigation={navigation}
        route={route}
        rightIcon={null}
        RightButton={null}
        goingBackHandler={undefined}
        IsRightIconDropDown={undefined}
      />
      
      <View style={styles.container}>
        {/* Report Type Tabs */}
        <View style={styles.tabSelectorContainer}>
          <TabSelector
            selectedType={reportType}
            onTypeChange={handleReportTypeChange}
          />
        </View>

        {/* Tab Content */}
        {reportType === 'WEEKLY' ? <WeeklyTabContainer date={date} /> : <DailyTabContainer date={date} /> }
      </View>
    </>
  );
};

const styles = ScaledSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  tabSelectorContainer: {
    backgroundColor: '#fff',
    paddingBottom: 18,
  },
}) as ReturnType<typeof StyleSheet.create>;

export default Earnings;
